import { Box } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import { useState } from 'react';
import { Avatar } from 'ui-components';
import { ImageUploader } from '~/components/ImageUploader';
import { ImageUploaderProps } from '~/components/ImageUploader/ImageUploader';
import { TalentValues } from '~/screens/AddTalent/ProfileInformation';

type Props = {
  pic?: string;
};

export const AvatarWithUpload = ({ pic }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [defaultImage, _setDefaultImage] = useState(pic);
  const { setFieldValue } = useFormikContext<TalentValues>();

  const [avatarImage, setAvatarImage] = useState<string | undefined>();

  const onSuccess: ImageUploaderProps['onSuccess'] = (
    croppedImage,
    { coordinates, originalImage },
  ) => {
    const previewUrl = croppedImage ? URL.createObjectURL(croppedImage) : '';
    setAvatarImage(previewUrl);
    setFieldValue('avatar', originalImage);
    setFieldValue('coordinates', coordinates);
    setFieldValue('croppedImage', croppedImage);
    setIsOpen(false);
  };

  const onReset = () => {
    setAvatarImage(undefined);
    setFieldValue('avatar', defaultImage);
    setIsOpen(false);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <Box>
      <Avatar
        size="xl"
        alt=""
        sx={{
          alignSelf: 'center',
        }}
        src={avatarImage || pic}
        onEdit={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setIsOpen(true);
        }}
        track-id="foam-talent-profileInformationModal-avatar"
      />
      <ImageUploader
        isOpen={isOpen}
        onSuccess={onSuccess}
        onReset={onReset}
        onClose={onClose}
      />
    </Box>
  );
};
